<div class="suggestion-complete-form__container">
    <h2 class="suggestion-complete-form__title">Completa tu actividad</h2>
    <p class="suggestion-complete-form__description">
        Comparte tu reflexión sobre cómo realizaste esta sugerencia y adjunta un archivo como evidencia (puede ser una
        imagen, documento o diario emocional).
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="suggestion-complete-form">
        <div class="form-group">
            <label for="reflection">✍️ Reflexión sobre la actividad</label>
            <textarea id="reflection" formControlName="reflection" rows="5"></textarea>
            <div *ngIf="form.get('reflection')?.invalid && form.get('reflection')?.touched" class="error">
                La reflexión es obligatoria y debe tener al menos 10 caracteres.
            </div>
        </div>

        <div class="form-group">
            <label for="file">📎 Evidencia (PDF, imagen, etc.)</label>
            <input type="file" id="file" (change)="onFileSelected($event)"
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx" />
            <div *ngIf="fileName">Archivo seleccionado: <strong>{{ fileName }}</strong></div>
        </div>

        <app-button type="submit" [disabled]="form.invalid || !selectedFile || isSubmitting">Enviar</app-button>
    </form>
</div>